import React from 'react';
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Plus, RefreshCw, ArrowRight, Sparkles, Dog, PawPrint } from "lucide-react";

const NewAnalysisModal = ({ isOpen, onOpenChange, onSelect, clearContext }) => {
  const handleOptionSelect = (option) => {
    if (option === 'new') {
      clearContext();
      onOpenChange(false);
      setTimeout(() => {
        window.location.href = '/dog-analyzer';
      }, 0);
    } else {
      onSelect("/dog-analyzer");
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-w-[92vw] p-0 gap-0 bg-gradient-to-b from-amber-50 to-white rounded-xl border-0">
        {/* Decorative Background Elements */}
    
        {/* Header Section */}
        <div className="relative p-6 sm:p-8 text-center border-b bg-gradient-to-r from-amber-100/50 to-amber-50/50">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-amber-300 to-amber-500 rounded-b-lg" />
          
          {/* Pet Icon */}
          <div className="mx-auto mb-3 relative">
            <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl transform rotate-12 shadow-lg flex items-center justify-center">
              <Dog className="w-8 h-8 sm:w-10 sm:h-10 text-white transform -rotate-12" />
            </div>
            <div className="absolute -bottom-2 right-1/2 transform translate-x-8">
              <PawPrint className="w-4 h-4 sm:w-5 sm:h-5 text-amber-600" />
            </div>
          </div>
          
          <h2 className="text-2xl sm:text-3xl font-bold text-amber-900">
            Crear Nuevo Análisis
          </h2>
        </div>
        
        <div className="p-4 sm:p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {/* Option 1: New Analysis */}
            <button
              onClick={() => handleOptionSelect('new')}
              className="group relative flex flex-col items-center p-6 sm:p-8 rounded-2xl 
                border-2 border-amber-200 hover:border-amber-400 
                bg-gradient-to-b from-white to-amber-50/50
                transition-all duration-300 hover:shadow-xl
                hover:-translate-y-1"
            >
              {/* Recommended Badge */}
              <div className="absolute -top-3 right-3 sm:right-4 bg-gradient-to-r from-amber-500 to-amber-600 
                  text-white px-3 py-1 rounded-full text-xs sm:text-sm font-medium shadow-lg
                  flex items-center gap-1.5 sm:gap-2">
                <Sparkles className="h-3 w-3 sm:h-4 sm:w-4" />
                Recomendado
              </div>

              {/* Icon Container */}
              <div className="relative mb-4">
                <div className="h-12 w-12 sm:h-16 sm:w-16 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 
                    flex items-center justify-center transform rotate-12 shadow-lg">
                  <Plus className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                </div>
                <div className="absolute -bottom-2 -right-2">
                  <PawPrint className="h-4 w-4 sm:h-5 sm:w-5 text-amber-600" />
                </div>
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-amber-900">Análisis desde Cero</h3>

              {/* Action Indicator */}
              <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 transform translate-x-2 group-hover:translate-x-4 transition-transform">
                <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6 text-amber-500" />
              </div>

              {/* Decorative Paw Print */}
              <div className="absolute bottom-2 left-2 opacity-20">
                <PawPrint className="h-4 w-4 text-amber-600" />
              </div>
            </button>

            {/* Option 2: Continue Analysis */}
            <button
              onClick={() => handleOptionSelect('continue')}
              className="group relative flex flex-col items-center p-6 sm:p-8 rounded-2xl 
                border-2 border-amber-100 hover:border-amber-300
                bg-white hover:bg-gradient-to-b hover:from-white hover:to-amber-50/30
                transition-all duration-300 hover:shadow-lg
                hover:-translate-y-1"
            >
              {/* Icon Container */}
              <div className="relative mb-4">
                <div className="h-12 w-12 sm:h-16 sm:w-16 rounded-2xl bg-gradient-to-br from-amber-300 to-amber-400 
                    flex items-center justify-center transform -rotate-12 shadow-lg">
                  <RefreshCw className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                </div>
                <div className="absolute -bottom-2 -right-2">
                  <PawPrint className="h-4 w-4 sm:h-5 sm:w-5 text-amber-600" />
                </div>
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-amber-900">Ver Análisis Actual</h3>

              {/* Action Indicator */}
              <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 transform translate-x-2 group-hover:translate-x-4 transition-transform">
                <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6 text-amber-400" />
              </div>

              {/* Decorative Paw Print */}
              <div className="absolute bottom-2 left-2 opacity-20">
                <PawPrint className="h-4 w-4 text-amber-600" />
              </div>
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NewAnalysisModal;